import { render, staticRenderFns } from "./ImageComponent.vue?vue&type=template&id=5f10294d&"
import script from "./ImageComponent.vue?vue&type=script&lang=js&"
export * from "./ImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports